import React from 'react';
import { useParams } from 'react-router-dom';

import { OfferConfigurePageContainer } from '@occc-app/offerHelpers/components/OfferConfigurePageContainer';
import { OfferType } from '@occc-app/offerValidationService/types';
import { useChainId } from '@occc-app/Chain/hooks';
import { getCreatePageLinks, useGetCampaignName } from '@occc-app/routes/CampaignComponents/utils';

import { PromotionConfigureFormContainer } from '../components/PromotionConfigureForm/PromotionConfigureFormContainer';
import { messages } from '../messages';
import { useGetIsOrderAheadEnabledForPromotion } from '../hooks/useGetIsOrderAheadEnabledForPromotion';

export const PromotionConfigurePageContainer: React.FC = () => {
  const { id: campaignId = '', promotionId = '' } = useParams<{
    id: string;
    promotionId: string;
  }>();
  const chainId = useChainId();
  const campaignName = useGetCampaignName(chainId, campaignId);
  const getIsOrderAheadEnabled = useGetIsOrderAheadEnabledForPromotion();

  return (
    <OfferConfigurePageContainer
      campaignId={campaignId}
      offerId={promotionId}
      getBreadcrumbLinks={(offerName) => getCreatePageLinks(campaignId, campaignName, offerName)}
      pageTitle={messages.configurePageTitle}
      subtitle={messages.subtitle}
      offerType={OfferType.Promotion}
      ConfigureFormContainer={PromotionConfigureFormContainer}
      getIsOrderAheadEnabled={getIsOrderAheadEnabled}
    />
  );
};
